import { render, staticRenderFns } from "./Express.vue?vue&type=template&id=65b6a216&"
import script from "./Express.vue?vue&type=script&lang=js&"
export * from "./Express.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports